import { render, staticRenderFns } from "./AddRecruterDialog.vue?vue&type=template&id=15a404cc"
import script from "./AddRecruterDialog.vue?vue&type=script&lang=js"
export * from "./AddRecruterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports